import { acceptInvite } from './acceptInvite'
import { activeIdea } from './activeIdea'
import { approveIdea } from './approveIdea'
import { assignCriteriaEvaluators } from './assignCriteriaEvaluators'
import { assignResponsibleToIdeaStep } from './assignResponsibleToIdeaStep'
import { changeChallenge } from './changeChallenge'
import { changeIdeaAuthor } from './changeIdeaAuthor'
import { completeWorkflowStep } from './completeWorkflowStep'
import { completeWorkflowTask } from './completeWorkflowTask'
import { createComment } from './createComment'
import { createForumComment } from './createForumComment'
import { createHistoryAttachment } from './createHistoryAttachment'
import { createIdea } from './createIdea'
import { createIdeaFieldTemplate } from './createIdeaFieldTemplate'
import { createIdeaWorkflowStep } from './createIdeaWorkflowStep'
import { deleteAllIdeaFieldTemplates } from './deleteAllIdeaFieldTemplates'
import { deleteAttachmentIdeaStep } from './deleteAttachmentIdeaStep'
import { deleteComment } from './deleteComment'
import { deleteForumComment } from './deleteForumComment'
import { deleteIdea } from './deleteIdea'
import { deleteIdeaFieldTemplate } from './deleteIdeaFieldTemplate'
import { deleteIdeaWorkflowStep } from './deleteIdeaWorkflowStep'
import { deleteTechnicalReview } from './deleteTechnicalReview'
import { downloadAttachment } from './downloadAttachment'
import { evaluateIdeaCriteria } from './evaluateIdeaCriteria'
import { calculateRoiRealTime } from './financialImpact/calculateRoiRealTime'
import { createFinancialImpact } from './financialImpact/createFinancialImpact'
import { getFinancialImpactByIdeaId } from './financialImpact/getFinancialImpact'
import { updateFinancialImpact } from './financialImpact/updateFinancialImpact'
import { finishWorkflow } from './finishWorkflow'
import { generateSequence } from './generateSequence'
import { generateWithAI } from './generateWithAI'
import { getAuthorIdeaUsers } from './getAuthorIdeaUsers'
import { getComments } from './getComments'
import { getDashboardFinancialCostsRevenues } from './getDashboardFinancialCostsRevenues'
import { getDashboardFinancialEstimatesByRoute } from './getDashboardFinancialEstimatesByRoute'
import { getDashboardFinancialImpact } from './getDashboardFinancialImpact'
import { getDashboardIdeaStatus } from './getDashboardIdeaStatus'
import { getDashboardIdeasByMonth } from './getDashboardIdeasByMonth'
import { getDashboardIdeasByStatus } from './getDashboardIdeasByStatus'
import { getDashboardIdeasByWorkflow } from './getDashboardIdeasByWorkflow'
import { getDashboardInvestmentOvertime } from './getDashboardInvestmentOvertime'
import { getDashboardTopFiveIdeas } from './getDashboardTopFiveIdeas'
import { getDashboardValidatedDataByRoute } from './getDashboardValidatedDataByRoute'
import { getFeed } from './getFeed'
import { getFields } from './getFields'
import { getIdea } from './getIdea'
import { getIdeaEvaluation } from './getIdeaEvaluation'
import { getIdeaFieldTemplates } from './getIdeaFieldTemplates'
import { getIdeaForum } from './getIdeaForum'
import { getIdeaRegistries } from './getIdeaRegistries'
import { getIdeaStatuses } from './getIdeaStatuses'
import { getIdeasToLink } from './getIdeasToLink'
import { getMyIdeas } from './getMyIdeas'
import { getSimilarIdeas } from './getSimilarIdeas'
import { getSimilarIdeasByText } from './getSimilarIdeasByText'
import { getWorkflow } from './getWorkflow'
import { insertWorkflowInIdea } from './insertWorkflowInIdea'
import { inviteUsers } from './inviteUsers'
import { likeIdea } from './likeIdea'
import { linkIdea } from './linkIdea'
import { listAvailableIdeaUsers } from './listAvailableIdeaUsers'
import { listFiltersIdea } from './listFiltersIdea'
import { listIdeas } from './listIdeas'
import { listIdeaUsers } from './listIdeaUsers'
import { notifyEvaluation } from './notifyEvaluation'
import { recuseIdea } from './recuseIdea'
import { recuseInvite } from './recuseInvite'
import { removeEvaluator } from './removeEvaluator'
import { removeEvaluatorReplicate } from './removeEvaluatorReplicate'
import { removeUsers } from './removeUsers'
import { requestChanges } from './requestChanges'
import { requestTechnicalOpinion } from './requestTechnicalOpinion'
import { toggleIdeaTag } from './toggleIdeaTag'
import { unlinkIdea } from './unlinkIdea'
import { updateComment } from './updateComment'
import { updateForumComment } from './updateForumComment'
import { updateIdea } from './updateIdea'
import { updateIdeaFieldTemplate } from './updateIdeaFieldTemplate'
import { updateIdeaStatus } from './updateIdeaStatus'
import { updateWorkflowTask } from './updateWorkflowTask'
import { uploadIdeaStepAttachment } from './uploadIdeaStepAttachment'
import { writeTechnicalReview } from './writeTechnicalReview'

export const ideasService = {
  calculateRoiRealTime,
  changeChallenge,
  changeIdeaAuthor,
  createForumComment,
  deleteForumComment,
  getDashboardIdeaStatus,
  getIdeaEvaluation,
  toggleIdeaTag,
  getIdea,
  getIdeaRegistries,
  inviteUsers,
  removeUsers,
  getFeed,
  getWorkflow,
  completeWorkflowStep,
  finishWorkflow,
  getIdeaForum,
  updateForumComment,
  getComments,
  createComment,
  updateComment,
  deleteComment,
  getIdeasToLink,
  linkIdea,
  unlinkIdea,
  requestChanges,
  createIdea,
  updateIdea,
  getFields,
  createIdeaFieldTemplate,
  deleteIdeaFieldTemplate,
  deleteAllIdeaFieldTemplates,
  updateIdeaFieldTemplate,
  getIdeaFieldTemplates,
  listIdeas,
  listFiltersIdea,
  assignCriteriaEvaluators,
  evaluateIdeaCriteria,
  requestTechnicalOpinion,
  writeTechnicalReview,
  getMyIdeas,
  deleteIdea,
  recuseIdea,
  activeIdea,
  recuseInvite,
  acceptInvite,
  getDashboardFinancialImpact,
  getDashboardIdeasByStatus,
  likeIdea,
  getDashboardIdeasByWorkflow,
  listAvailableIdeaUsers,
  listIdeaUsers,
  insertWorkflowInIdea,
  approveIdea,
  getDashboardInvestmentOvertime,
  getDashboardFinancialEstimatesByRoute,
  getDashboardValidatedDataByRoute,
  getDashboardIdeasByMonth,
  getDashboardFinancialCostsRevenues,
  getDashboardTopFiveIdeas,
  removeEvaluator,
  generateWithAI,
  getIdeaStatuses,
  updateIdeaStatus,
  getAuthorIdeaUsers,
  getSimilarIdeas,
  getSimilarIdeasByText,
  createHistoryAttachment,
  updateWorkflowTask,
  removeEvaluatorReplicate,
  assignResponsibleToIdeaStep,
  completeWorkflowTask,
  generateSequence,
  createFinancialImpact,
  updateFinancialImpact,
  getFinancialImpactByIdeaId,
  createIdeaWorkflowStep,
  deleteIdeaWorkflowStep,
  uploadIdeaStepAttachment,
  deleteAttachmentIdeaStep,
  downloadAttachment,
  deleteTechnicalReview,
  notifyEvaluation,
}
